import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=0f5b3308&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=ts&"
export * from "./Footer.vue?vue&type=script&lang=ts&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=0f5b3308&prod&scoped=true&lang=css&"
import style1 from "./Footer.vue?vue&type=style&index=1&id=0f5b3308&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5b3308",
  null
  
)

export default component.exports